define(function (require) {

    var Marionette = require('marionette');
    var ModelMenu = require('./model');
    var MenuStructure = require('./structure');
    var AppConfig = require("config/application");
    var I18n = require('i18n!nls/main');

    var MenuCollection = Backbone.Collection.extend({
        model: ModelMenu,
        defaultGlobalName: 'SideMenu', // app.Collection.SideMenu
        comparator: 'position',

        initialize: function (models, options) {
            this.setAvailableGlobal(options);
            this.reset(MenuStructure.getMenu());
        },

        parse: function (response, options) {
            var menu;
            var sources;
            if (response.status != 1 || !response.result || !response.result.stats_sources || !response.result.stats_sources.length) {
                if(response.result.stats_sources || !response.result.stats_sources.length) {
                    sources = [{
                        name: I18n.menu.no_sources,
                        class: 'disabled'
                    }];
                } else {
                    this.statisticSources = [];
                    return MenuStructure.getMenu();
                }
            } else {
                sources = response.result.stats_sources;
            }

            return this.prepareData(sources);
        },

        prepareData: function (sources) {
            if(sources && sources.length) {
                sources.map(function (item, index) {
                    item.title = item.name;
                    item.link = item.id ? '#statistic/source/' + item.id : 'javascript:{}';
                    item.position = index;
                });
            }

            this.statisticSources = sources;

            return MenuStructure.getMenu(sources);
        },

        getStatisticSources:function(){
            return this.statisticSources;
        },
        
        setAvailableGlobal: function (options) {
            if (options && options.globalName) {
                MenuCollection.globalName = options.globalName
            }

            if (!MenuCollection.globalName) {
                MenuCollection.globalName = this.defaultGlobalName;
            }

            app.Collections[MenuCollection.globalName] = this;
        },
    });

    return MenuCollection;
});
